import { string, func, bool } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { IndexLink } from "react-router";
import { get } from "lodash";
import { Container, Menu, Icon, Grid } from "semantic-ui-react";
import PageMenu from "./PageMenu";

import "./pageMenu.scss";

const PageNavigation = props => {
  const {
    unitId,
    rootPath,
    projectId,
    onToggleSidebar,
    sidebarIsVisible,
    accountLogoUrl
  } = props;

  return (
    <div data-component="pageNavigation">
      <Container data-component="pageMenuSmall" className="mobile-visible">
        <Grid style={{ height: "85px" }}>
          <Grid.Column width={3} verticalAlign="middle">
            <a
              className="toc item"
              onClick={onToggleSidebar}
              id="sidebarToggle"
            >
              <Icon
                name={sidebarIsVisible ? "x" : "sidebar"}
                size="large"
                data-attr="nav-icon"
              />
            </a>
          </Grid.Column>
          <Grid.Column width={13} verticalAlign="middle" textAlign="right">
            <IndexLink
              to={rootPath || "/"}
              className="logo"
              style={
                accountLogoUrl
                  ? { backgroundImage: `url(${accountLogoUrl})` }
                  : null
              }
            />
          </Grid.Column>
        </Grid>
      </Container>
      <Container data-component="pageMenuLarge" className="mobile-hidden">
        <div>
          <Menu pointing secondary stackable data-component="defaultMenu">
            <Menu.Item as="div" name="home" style={{ verticalAlign: "middle" }}>
              <IndexLink
                to={rootPath || "/"}
                className="logo"
                style={
                  accountLogoUrl
                    ? { backgroundImage: `url(${accountLogoUrl})` }
                    : null
                }
              />
            </Menu.Item>

            <PageMenu
              projectId={projectId}
              unitId={unitId}
              sidebarIsVisible={sidebarIsVisible}
              onToggleSidebar={onToggleSidebar}
            />
          </Menu>
        </div>
      </Container>
    </div>
  );
};

PageNavigation.propTypes = {
  onToggleSidebar: func.isRequired,
  projectId: string,
  rootPath: string,
  accountLogoUrl: string.isRequired,
  sidebarIsVisible: bool.isRequired,
  unitId: string
};

PageNavigation.defaultProps = {
  projectId: null,
  rootPath: "",
  unitId: null
};

const mapStateToProps = state => ({
  accountLogoUrl: get(state, "branding.account.logo.half_banner"),
  i18n: state.i18n
});

export default connect(mapStateToProps)(PageNavigation);
